import { render } from "./tax-rates-modal.vue?vue&type=template&id=21246720"
import script from "./tax-rates-modal.vue?vue&type=script&lang=js"
export * from "./tax-rates-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__